import React, { useState } from "react"

import classNames from "gpages/utils/classnames"
import { useNavScrollHide } from "gpages/hooks/common"
import { scrollToTarget } from "gpages/utils/common"

import * as styles from "./nav.module.scss"
import logoImg from "@images/nav-logo.jpg"
import config from "@config"
import Clickable from "../clickable"
import { useAppContext } from "@src/context/appContext"
import burgerImg from "@images/nav-bars.png"
import buyImg from "@images/buy.png"

const items = [
  { name: "票务信息", key: "ticket_info" },
  { name: "活动介绍", key: "intro" },
  { name: "会场地图", key: "map" },
  { name: "游戏玩法", key: "play" },
  { name: "舞台活动", key: "stage" },
  { name: "参展厂商", key: "exhibitor" },
  { name: "参展游戏", key: "games" },
  { name: "嘉宾阵容", key: "guests" },
  { name: "合作伙伴", key: "partners" },
  { name: "合作媒体", key: "media" },
  { name: "机核品牌", key: "brands" },
  { name: "立刻购票", url: config.data.ticketUrl },
]

const DesktopNav = ({ location, visible }) => {
  return (
    <nav className={classNames(styles.nav, { [styles.visible]: visible })}>
      <img src={logoImg} alt="logo" className={styles.logo} />
      <div className={styles.right}>
        {items.map((item) => {
          return (
            <Clickable
              key={item.name}
              appNavTo={item.url}
              href={item.key ? `#${item.key}` : undefined}
              onClick={(e) => {
                const scrolled = scrollToTarget(e.currentTarget)
                if (scrolled) {
                  e.preventDefault()
                }
              }}
            >
              {item.name}
            </Clickable>
          )
        })}
      </div>
    </nav>
  )
}

const MobileNav = ({ location, visible }) => {
  const [dropdownVisble, setDropdownVisible] = useState(false)
  return (
    <>
      <div
        className={classNames(styles.mask, {
          [styles.visible]: dropdownVisble,
        })}
        onClick={() => setDropdownVisible(false)}
      />
      <nav
        className={classNames(styles.nav, styles.mobileNav, {
          [styles.visible]: dropdownVisble || visible,
          [styles.isDropdown]: dropdownVisble,
        })}
      >
        <img src={logoImg} alt="logo" className={styles.logo} />
        <div className={styles.right}>
          <Clickable
            className={styles.burger}
            onClick={() => setDropdownVisible((x) => !x)}
          >
            <img src={burgerImg} alt="menu" />
          </Clickable>
        </div>
        <div className={styles.menuList}>
          {items.map((item) => {
            return (
              <Clickable
                key={item.name}
                appNavTo={item.url}
                href={item.key ? `#${item.key}` : undefined}
                onClick={(e) => {
                  setDropdownVisible(false)
                  const scrolled = scrollToTarget(e.currentTarget)
                  if (scrolled) {
                    e.preventDefault()
                  }
                }}
              >
                {item.name}
              </Clickable>
            )
          })}
        </div>
      </nav>
    </>
  )
}

const Nav = ({ location }) => {
  const visible = useNavScrollHide(1000, [false, true])

  const { isAppLayout } = useAppContext()

  const renderNav = () => {
    if (isAppLayout) {
      return <MobileNav location={location} visible={visible} />
    }

    return <DesktopNav location={location} visible={visible} />
  }

  return (
    <>
      {renderNav()}
      <Clickable
        interactivity="true"
        className={classNames(styles.buyBtn, {
          [styles.visible]: visible,
        })}
        appNavTo={config.data.ticketUrl}
      >
        <img src={buyImg} alt="buy" />
      </Clickable>
    </>
  )
}

export default Nav
